
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import dialogCom from "@/components/ModelCom.vue";
export default Vue.extend({
  components: { action, dialogCom },
  data() {
    return {
      items: [] as any[],
      spanArr: [] as number[], // 存放每一行要合并的行数
      pos: 0, // 当前分组起始索引
      current: null as any,
      detail: null as any,
      inApprove: [] as any[],
      form: {
        approveKpiDetails: [] as any[],
      } as any,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    async approve() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.detail = await HttpUtil.XCHttpPost(
        Urls.GetKpiDetail,
        this.current.sid,
        true,
        false
      );
      this.inApprove = this.detail.kpiDetails.filter((x: any) => x.type == 1);
      const dialog: any = this.$refs.dialog;
      dialog.show();
    },
    closeDialog() {
      const dialog: any = this.$refs.dialog;
      dialog.hiden();
    },
    async onSubmit() {
      this.form.kpiSid = this.current.sid;
      this.form.approveKpiDetails = [];
      this.inApprove.forEach((x: any) => {
        this.form.approveKpiDetails.push({
          kpiDetailSid: x.sid,
          score: x.score,
        });
      });
      await HttpUtil.XCHttpPost(Urls.ApproveKpi, this.form, true, false);
      this.$router.push({ path: `/KPI?sid=${this.form.kpiSid}` });
    },
    async getList() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const ret: any = await DeviceRequestBill.GetKpiList(content, 1, 1000, true);
      this.items = ret.data;
    },
    async insert() {
      await HttpUtil.XCHttpPost(Urls.CreateKpi, "", true, false);
      await this.getList();
    },
    currentChange(val: any) {
      this.current = val;
    },
  },
});
